/**
 * Stand-in knowledge base. Swap the whole module out — or just point
 * `RestTransport` at a real endpoint — with zero UI changes.
 */
export const MOCK_ANSWERS = [
    {
        match: ['refund', 'money back', 'cancel order'],
        reply: "You can request a refund within **30 days** of purchase.\n\nHere's how:\n1. Open **Orders** in your account\n2. Pick the order, then choose **Request refund**\n3. Select a reason and submit\n\nRefunds land back on the original payment method in 5–10 business days.",
        sources: [
            { id: 's1', title: 'Refund policy', url: 'https://example.com/help/refunds', snippet: 'Orders are refundable for 30 days from the delivery date.' },
            { id: 's2', title: 'Processing times', url: 'https://example.com/help/timing' },
        ],
        suggestions: [
            { id: 'q1', label: 'How long do refunds take?' },
            { id: 'q2', label: 'I never received my order' },
        ],
    },
    {
        match: ['password', 'log in', 'login', 'sign in', 'locked out'],
        reply: "Let's get you back in.\n\n1. Go to the sign-in page and choose **Forgot password**\n2. Enter the email on the account\n3. Follow the reset link — it expires after 60 minutes\n\nIf the email doesn't arrive within a few minutes, check spam or try a different address you may have signed up with.",
        sources: [{ id: 's3', title: 'Resetting your password', url: 'https://example.com/help/password' }],
        suggestions: [
            { id: 'q3', label: "The reset email never arrived" },
            { id: 'q4', label: 'Change the email on my account' },
        ],
    },
    {
        match: ['price', 'pricing', 'plan', 'cost', 'subscription', 'billing'],
        reply: 'We have three plans:\n\n- **Starter** — free, up to 3 projects\n- **Pro** — $18/seat/month, unlimited projects and priority support\n- **Enterprise** — custom pricing, SSO, audit logs and a dedicated CSM\n\nAnnual billing takes 20% off Pro. You can switch plans at any time and we prorate the difference.',
        sources: [{ id: 's4', title: 'Plans & pricing', url: 'https://example.com/pricing' }],
        suggestions: [
            { id: 'q5', label: 'What counts as a seat?' },
            { id: 'q6', label: 'Do you offer a nonprofit discount?' },
        ],
    },
    {
        match: ['integrate', 'embed', 'install', 'widget', 'api', 'sdk'],
        reply: 'You can drop the assistant onto any page with two lines:\n\n```html\n<script src="https://cdn.example.com/agentic-chat.js"></script>\n<script>AgenticChat.init({ apiKey: "pk_live_..." })</script>\n```\n\nIt mounts in a shadow root, so it inherits none of your page styles and leaks none of its own. On phones it opens as a full-screen sheet; on desktop as a docked panel.',
        sources: [
            { id: 's5', title: 'Embed guide', url: 'https://example.com/docs/embed' },
            { id: 's6', title: 'JavaScript API reference', url: 'https://example.com/docs/api' },
        ],
        suggestions: [
            { id: 'q7', label: 'Can I control it from my own button?' },
            { id: 'q8', label: 'How do I theme it?' },
        ],
    },
    {
        match: ['human', 'agent', 'person', 'support', 'representative', 'talk to someone'],
        reply: "Of course — I can pass you to a teammate. They're online now and typically reply in under 3 minutes.\n\nWant me to hand this conversation over? They'll see everything we've discussed so you won't have to repeat yourself.",
        actions: [{ id: 'a1', type: 'handoff', label: 'Talk to a person' }],
    },
];
export const MOCK_FALLBACK = "I don't have a confident answer for that yet.\n\nI can search our help centre with different wording, or hand you to a teammate who can dig into the specifics of your account.";
export const MOCK_FALLBACK_ACTIONS = [
    { id: 'a2', type: 'handoff', label: 'Talk to a person' },
];
export const MOCK_GREETING = "Hi! 👋 I'm CAIRA, your AlignBooks AI assistant.\n\nAsk me anything about features, pricing, integrations or setup — I'll answer straight away, and pull in a teammate if I get stuck.";
export const MOCK_GREETING_SUGGESTIONS = [
    { id: 'g1', label: 'How do refunds work?' },
    { id: 'g2', label: 'I can’t log in' },
    { id: 'g3', label: 'What does Pro cost?' },
    { id: 'g4', label: 'How do I embed the widget?' },
];
export function findAnswer(question) {
    const q = question.toLowerCase();
    return MOCK_ANSWERS.find((entry) => entry.match.some((keyword) => q.includes(keyword)));
}
